import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ProductAddress from './components/declaration/ProductAddress.vue'
import ResaleCompany from './components/resale/Company.vue'

Vue.use(VueI18n)

const locales = {
	"nl": {
		"currency": {
			"style": "currency", "currency": "EUR"
		}
	},
	"en": {
		"currency": {
			"style": "currency", "currency": "USD"
		}
	}
}

const i18n = new VueI18n({
	locale: 'nl',
	locales
})

new Vue({
	i18n,
	components: {
		'product-address': ProductAddress,
		'resale-company': ResaleCompany
	}
}).$mount('#declaration', '#resale')



// WEBPACK FOOTER //
// ./src/main.js